import Cookies from 'universal-cookie';
import format from 'format-util';

const LEVELS = ['none', 'message', 'warn', 'info', 'log', 'debug', 'trace'];
const DEFAULT_LEVEL = 'debug';
export const LOG_SETTING_KEY = 'enableLogging'
export const LOG_LEVELS = {};
LEVELS.forEach(function(level) {
  LOG_LEVELS[level.toUpperCase()] = level;
  LOG_LEVELS[level.toLowerCase()] = level;
});

const loggingDisabled = !(new Cookies()).get(LOG_SETTING_KEY);
const DO_NOTHING_FUNCTION = function() {};

class Logger {
    
    static isLoggingDisabled() {
        return loggingDisabled;
    }

    constructor(scope, startingLevel) {
        let levelIndex = LEVELS.indexOf(startingLevel.toLowerCase() || DEFAULT_LEVEL);
        levelIndex = levelIndex < 0 ? 0 : levelIndex;
        this.logLevel = startingLevel;
        this.scope = scope;
        //Create a function for each levels
        let logFunctionGenerator = function(level, index) {
            if(Logger.isLoggingDisabled() || levelIndex < index) {
                this[level] = DO_NOTHING_FUNCTION;
            } else {
                this[level] = function() {
                    const args = [].slice.call(arguments);
                    if (args[0]) {
                        args[0] = format('[%s]-[%s]: ', level.toUpperCase(), scope, args[0]);
                    }
                    console.log.apply(console, args);
                }
            }
        };
        logFunctionGenerator = logFunctionGenerator.bind(this);
        LEVELS.forEach(logFunctionGenerator);
    }

    getScope() {
        return this.scope;
    }

    getLogLevel() {
        return this.logLevel;
    }
}

export default Logger;